<template>
  <v-container fluid>
    <v-row justify="end" align="center">
      <v-switch
        label="Open/Close All Groups"
        class="pr-3 py-0 my-0"
        v-model="togglePanels"
        hide-details
      ></v-switch>
      <div>
        <list-visible-columns-and-filter
          :visible-columns="visibleColumns"
          :selectable-headers="selectableHeaders"
          :hide-search="true"
          @change="onVisibleColumnsChange"
        ></list-visible-columns-and-filter>
      </div>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-expansion-panels multiple v-model="panels">
          <v-expansion-panel
            v-for="scenario in scenarios"
            :key="`scenario-${scenario.id}`"
          >
            <v-expansion-panel-header class="title"
              >{{ scenario.name }} - {{ scenario.description }}
              {{
                scenario.totalPrice ? ` - Total: ${scenario.totalPrice}` : ""
              }}</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <scenario
                :ref="scenario.id"
                :visible-columns="visibleColumns"
                :headers="headers"
                :itineraryItems="items"
                :itineraryParticipants="itineraryParticipants"
                :scenario="scenario"
                :summary="summary"
                @change="onScenarioChange"
                @remove="onRemove"
                :scenarios="scenarios"
              ></scenario>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12"> <v-divider></v-divider></v-col>
    </v-row>
    <v-row>
      <v-col cols="12"
        ><v-row justify="center">
          <strong>Total Service Groups: </strong> &nbsp;{{
            allScenariosTotal | priceLabeler
          }}, &nbsp; <strong>Itinerary Total:</strong>&nbsp;{{
            itineraryTotalPrice | priceLabeler
          }}
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="center" align="center" v-if="scenarios.length == 0">
      <v-btn
        class="mx-2"
        fab
        dark
        large
        color="blue darken-1"
        @click="onAddScenario"
      >
        <v-icon dark>mdi-ballot</v-icon>
      </v-btn>
    </v-row>
    <v-container pt-0>
      <v-row justify="center" class="pt-1">
        <v-btn @click="onAddScenario" text color="primary">
          <v-icon v-if="scenarios.length > 0">mdi-plus-circle</v-icon>Add New
          Service Group
        </v-btn>
      </v-row>
    </v-container>

    <v-row v-if="debug">
      <code>p:{{ csvData }}</code>
    </v-row>
    <confirmation-dialog
      :item="selectedScenario"
      :showDialog="showConfirmationDialog"
      @onConfirm="deleteScenario"
      @onCloseDialog="showConfirmationDialog = false"
    >
      <template slot="message">This will remove service group.</template>
    </confirmation-dialog>
    <v-divider></v-divider>
    <v-container>
      <v-row justify="center" align="center"
        ><v-btn class="ma-1" @click="onDownloadHTML"
          >Download HTML <v-icon right>mdi-language-html5</v-icon>
        </v-btn>
        <download-csv :data="csvData" delimiter=",">
          <v-btn class="mr-1" @click="onDownloadCSV"
            ><v-icon left small>mdi-file-delimited</v-icon> Get CSV</v-btn
          >
        </download-csv>
        <v-btn @click="$emit('save')" color="primary">Save</v-btn></v-row
      >
    </v-container>
  </v-container>
</template>

<script>
const randomize = require("randomatic");
import Scenario from "./Scenario";
import ConfirmationDialog from "../../shared/ConfirmationDialog";
import ListVisibleColumnsAndFilter from "../../shared/ListVisibleColumnsAndFilter";
import SimpleListMixin from "../../../../mixins/SimpleListMixin";
import { downloadHtml } from "../../../../helpers/index";
export default {
  name: "service-groups",
  mixins: [SimpleListMixin],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    itineraryParticipants: {
      type: Array,
      default: () => [],
    },
    itinerary: {
      type: Object,
      default: () => null,
    },
  },
  components: { Scenario, ConfirmationDialog, ListVisibleColumnsAndFilter },
  data() {
    return {
      debug: false,
      selectedScenario: {},
      showConfirmationDialog: false,
      panels: [],
      togglePanels: true,
      visibleColumns: this.$store.getters.localSettings(this.$options.name, [
        "startDate",
        "supplierName",
        "serviceName",
        "ratePlan",
        "adultSell",
        "childSell",
        "itiAdults",
        "itiChildren",
        "remainingAdults",
        "remainingChildren",
        "adults",
        "adult",
        "children",
        "child",
      ]),
      headers: [
        {
          text: "Date",
          value: "startDate",
          name: "startDate",
          sortable: true,
          editable: false,
        },
        {
          text: "Supplier",
          value: "supplierName",
          name: "supplierName",
          sortable: true,
          editable: false,
        },
        {
          text: "Service",
          value: "serviceName",
          name: "serviceName",
          sortable: true,
          editable: false,
        },
        {
          text: "Rate Plan",
          value: "ratePlan",
          name: "ratePlan",
          sortable: false,
          editable: false,
        },
        {
          text: "Adult Sell",
          value: "adultSell",
          name: "adultSell",
          sortable: false,
          editable: false,
        },
        {
          text: "Child Sell",
          value: "childSell",
          name: "childSell",
          sortable: false,
          editable: false,
        },
        {
          text: "Infant Sell",
          value: "infantSell",
          name: "infantSell",
          sortable: false,
          editable: false,
        },
        {
          text: "Iti Adults",
          value: "itiAdults",
          name: "itiAdults",
          sortable: false,
          editable: false,
        },

        {
          text: "Iti Children",
          value: "itiChildren",
          name: "itiChildren",
          sortable: false,
          editable: false,
        },
        {
          text: "Iti Infants",
          value: "itiInfants",
          name: "itiInfants",
          sortable: false,
          editable: false,
        },
        {
          text: "Remaing Adults",
          value: "remainingAdults",
          name: "remainingAdults",
          sortable: false,
          editable: false,
        },
        {
          text: "Remaining Children",
          value: "remainingChildren",
          name: "remainingChildren",
          sortable: false,
          editable: false,
        },
        {
          text: "Remaining Infants",
          value: "remainingInfants",
          name: "remainingInfants",
          sortable: false,
          editable: false,
        },
        {
          text: "Adults",
          value: "adults",
          name: "adults",
          sortable: false,
          editable: true,
        },
        {
          text: "Children",
          value: "children",
          name: "children",
          sortable: false,
          editable: true,
        },
        {
          text: "Infants",
          value: "infants",
          name: "infants",
          sortable: false,
          editable: true,
        },
        {
          text: "Adult $",
          value: "adultsPrice",
          name: "adultsPrice",
          sortable: false,
          editable: true,
        },
        {
          text: "Child $",
          value: "childrenPrice",
          name: "childrenPrice",
          sortable: false,
          editable: true,
        },
        {
          text: "Infant $",
          value: "infantsPrice",
          name: "infantsPrice",
          sortable: false,
          editable: true,
        },
        {
          text: "Included",
          value: "isIncluded",
          name: "isIncluded",
          sortable: false,
          editable: false,
        },
        {
          text: "Optional",
          value: "isOptional",
          name: "isOptional",
          sortable: false,
          editable: false,
        },
      ],
      scenarios: this.value ? [...this.value] : [],
      csvData: [],
    };
  },

  computed: {
    itineraryTotalPrice() {
      return this.itinerary ? this.itinerary.totalPrice : 0;
    },
    allScenariosTotal() {
      return this.scenarios && this.scenarios.length > 0
        ? this.scenarios.reduce(
            (t, s) => t + Number(s.totalPrice ? s.totalPrice : 0),
            0
          )
        : 0;
    },
    summary() {
      const servicesAndExtras = this.items.reduce(
        (a, item) => [
          ...a,
          item,
          ...item.extras.map((e) => {
            return {
              ...e,
              adults: e.rateBase == "I" ? item.adults : e.adults,
              children: e.rateBase == "I" ? item.children : e.children,
              infants: e.rateBase == "I" ? item.infants : e.infants,
            };
          }),
        ],
        []
      );
      //create summary using services AND extras
      return servicesAndExtras.reduce((t, item) => {
        if (!t[item.id]) {
          const adults = item.adults ? Number(item.adults) : 0;
          const children = item.children ? Number(item.children) : 0;
          const infants = item.infants ? Number(item.infants) : 0;
          t[item.id] = { adults, children, infants };
          for (let paxType of ["adults", "children", "infants"]) {
            const remaining = this.scenarios.reduce((r, scenarios) => {
              const scenarioItem = scenarios.items.find(
                (i) => i.itineraryItemId == item.id
              );
              if (scenarioItem) {
                r = r - Number(scenarioItem[paxType]);
              }
              return r;
            }, Number(item[paxType]));
            t[item.id][
              `remaining${paxType.charAt(0).toUpperCase() + paxType.slice(1)}`
            ] = remaining;
          }
        }
        return t;
      }, {});
    },
  },
  methods: {
    onDownloadCSV() {
      this.csvData = this.getCsvData();
    },
    getCsvData() {
      const lines = [];
      for (const ref of Object.keys(this.$refs)) {
        const scenario = this.$refs[ref][0].getData();
        for (const item of scenario.csvData) {
          lines.push(this.scenarioItem2Csv(scenario, item));
        }
      }
      lines.push({
        "Service Group Name": "-",
        "Service Group Description": "-",
        Date: "-",
        Supplier: "-",
        Service: "-",
        Adults: "-",
        Children: "-",
        "Adult Price PP": "-",
        "Child Price PP": "Grand Total:",
        Total: this.allScenariosTotal,
      });
      return lines;
    },
    scenarioItem2Csv(scenario, item) {
      return {
        "Service Group Name": scenario.name,
        "Service Group Description": scenario.description,
        ...item,
      };
    },
    onDownloadHTML() {
      let html = "";
      for (const ref of Object.keys(this.$refs)) {
        const scenario = this.$refs[ref][0].getData();
        //console.log(scenario);
        html += `<h1>${scenario.name}</h1>`;
        html += `<p>${scenario.description}</p>`;
        html += `<h3>Participants:</h3>`;
        html += "<table>";
        html +=
          "<thead><tr><th>Title</th><th>Name</th><th>Surname</th></tr></thead><tbody>";
        for (const p of scenario.participants) {
          html += `<tr><td>${p.title}</td><td>${p.name}</td><td>${p.surname}</td></tr>`;
        }
        html += "</tbody></table>";
        html += `<h3>Pricing:</h3>`;
        html += "<table>";
        html += `<thead><tr>${Object.keys(scenario.csvData[0])
          .map((k) => `<th>${k}</th>`)
          .join("")}</tr></thead><tbody>`;
        for (const r of scenario.csvData) {
          html += `<tr>${Object.keys(r)
            .map((k) => `<td>${r[k]}</td>`)
            .join("")}</tr>`;
        }
        html += "</tbody></table>";
        html += "<hr>";
      }

      downloadHtml("service-groups.html", html);
    },
    onRemove(payload) {
      this.selectedScenario = { ...payload };
      this.showConfirmationDialog = true;
    },
    deleteScenario(payload) {
      this.showConfirmationDialog = false;
      this.scenarios = [...this.scenarios.filter((s) => s.id != payload.id)];
      this.$emit("change", [...this.scenarios]);
      this.$emit("input", [...this.scenarios]);
    },
    onAddScenario() {
      const servicesAndExtras = this.items.reduce(
        (a, item) => [...a, item, ...item.extras],
        []
      );
      //const servicesAndExtras = [...this.items]
      const scenarioNo = this.scenarios.length + 1;
      this.panels.push(this.scenarios.length);
      this.scenarios.push({
        id: randomize("Aa0", 32),
        name: `Service Group ${scenarioNo}`,
        description: "",
        //items: [...this.items.map(this.toScenarioItem)]
        items: [...servicesAndExtras.map(this.toScenarioItem)],
        participants: [],
      });
    },
    toScenarioItem(item) {
      return {
        itineraryItemId: item.id,
        adults: 0,
        children: 0,
        infants: 0,
      };
    },
    onScenarioChange(payload) {
      //this.scenarios = [...this.scenarios.filter(s => s.id != payload.id)];
      const editedIndex = this.scenarios.map((s) => s.id).indexOf(payload.id);
      Object.assign(this.scenarios[editedIndex], payload);
      this.$emit("input", [...this.scenarios]);
    },
  },

  watch: {
    value(newScenarios) {
      this.scenarios = [...newScenarios];
    },
    togglePanels(newVal) {
      //console.log("togglePanels", newVal);
      if (newVal) {
        this.panels = [...this.scenarios.map((item, i) => i)];
      } else {
        this.panels = [];
      }
    },
  },

  created() {
    //console.log("creatd", this.items);
    this.panels = [...this.scenarios.map((item, i) => i)];
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/scenarios/ServiceGroups.vue